import PosterCarousel from "./PosterCarousel";
import QueryBoundary from "../../components/ui/QueryBoundary";
import useApiQuery from "../../hooks/useApiQuery";
import endpoints from "../../api/endpoints";
import { mergeCatalog } from "../../lib/catalog";

const PurchasesTab = () => {
  const query = useApiQuery(endpoints.purchasedList(), {
    select: mergeCatalog,
  });

  return (
    <QueryBoundary
      {...query}
      isEmpty={(items) => items.length === 0}
      emptyMessage="هنوز فیلمی خریداری نکرده‌اید."
    >
      {(items) => <PosterCarousel items={items} />}
    </QueryBoundary>
  );
};

export default PurchasesTab;
